<template>
  <van-popup
    v-model:show="show"
    round
    closeable
    :style="{
      width: '90%',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      background: '#f0f3f5',
    }"
  >
    <div class="statement-bg">
      <div class="content" v-html="statement"></div>
      <wx-open-launch-app
        id="launch-btn"
        appid="wxc9da92efaf026389"
        :extinfo="exinfo"
        style="width: 80%; height: 40px"
        @launch="handleLaunch"
        @error="handleError"
      >
        <div v-is="'script'" type="text/wxtag-template">
          <button
            style="
              background: linear-gradient(to right, #f48260, #e53531);
              border-width: 0;
              font-size: 5.5vw;
              color: #fff;
              font-weight: 400;
              text-align: center;
              width: 100%;
              height: 40px;
              border-radius: 20px;
            "
            class="btn"
          >
            <span>打开中山+新闻客户端</span>
          </button>
        </div>
      </wx-open-launch-app>
    </div>
  </van-popup>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { Popup } from "vant";
import { Button } from "vant";
import "@/plugins/bridge.js";

export default {
  name: "Statement",
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  setup() {
    const store = useStore();
    const showBtn = ref(false);
    const showWechatBtn = ref(false);
    // const isAndroid = ref(false)
    const userAgentString = navigator.userAgent.toLowerCase();
    if (userAgentString.indexOf("zsrbapp") < 0) {
      showBtn.value = true;
    }

    if (userAgentString.indexOf("micromessenger") >= 0) {
      showWechatBtn.value = true;
    }

    // if (userAgentString.indexOf("Android") > -1) {
    //   isAndroid = true
    // }

    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };

    const handleError = (e) => {
      console.log("handleError", e);
      window.open(store.state.apkLink, "_blank");
    };

    return {
      statement: computed(() => store.state.statement),
      exinfo: computed(() => store.state.exinfo),
      showBtn,
      showWechatBtn,
      userAgentString,
      handleLaunch,
      handleError,
    };
  },
  computed: {
    show: {
      get() {
        return this.$store.state.showStatement;
      },
      set(value) {
        this.$store.commit("updateShowStatement", value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.launch-btn-box {
  margin: 12px 0;
}
.statement-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 15rem;
  text-align: left;
  margin: 0.9375rem 0;
  padding: 0.3125rem 0.625rem;
  overflow-y: auto;
  .title {
    text-align: center;
    font-size: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  .content {
    text-align: justify;
    font-size: 4vw;
    padding: 10px;
  }
}
</style>
